export const getIsVisible = (isDAWPlugin: boolean, sampleCount: number) =>
    !isDAWPlugin && sampleCount !== 0;
